import { useEffect } from "react";
import { useSession } from "next-auth/react";
import { useGlobalState } from "../context/GlobalStateContext";

const StoreAuthData = () => {
  const { isLoading, isExternalAuth, setLoading, setAuthState, clearAuthState } = useGlobalState();
  const { data: session } = useSession();
  const { language } = useGlobalState();

  const loading = {
    ar: "تحميل...",
    fr: "Chargement...",
  };

  useEffect(() => {
    if (session === undefined) {
      return;
    }
    if (session) {
      const token = session?.["token"];
      const id = session?.["id"] || "";
      const name = session?.user?.name || "";
      const email = session?.user?.email || "";
      const phone = session?.["phone"] || "";
      const picture = session?.["picture"] || "";
      setAuthState({
        user: { id, name, picture, email, phone },
        token,
        isLoggedIn: !!token,
        isExternalAuth: true,
      });
    } else if (isExternalAuth) {
      // session is null
      clearAuthState();
    }
    setLoading(false);
  }, [session]);

  return (
    isLoading && (
      <div className="fixed inset-0 flex flex-col gap-2 items-center justify-center bg-white z-[9999]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-yellow md:h-16 md:w-16 md:border-b-4 md:border-t-4"></div>
        <div className="">{loading[language]}</div>
      </div>
    )
  );
};

export default StoreAuthData;
